// useGizmoManager.js
import useSocketGizmo from './useSocketGizmo';
import useGroundingGizmo from './useGroundingGizmo';
import useGroundingGizmoEvents from './useGroundingGizmoEvents';
import useSocketGizmoEvents from './useSocketGizmoEvents';
import useLightSwitchGizmo from './useLightSwitchGizmo';
import useLightingGizmoEvents from './useLightingGizmoEvents';
import useMachineGizmo from './useMachineGizmo';
import useMachineGizmoEvents from './useMachineGizmoEvents';
import { useFixtureGizmo } from './useFixtureGizmo'; // ✅ Fixture wire spline gizmo
import useFixtureRotateGizmo from './useFixtureRotateGizmo'; // ✅ Fixture mesh rotate gizmo visibility
import useFixtureRotateEvents from './useFixtureRotateEvents'; // ✅ Fixture mesh rotate handler
import { useGizmo } from './useGizmo';  // ✅ Wire gizmo interaksiyonu
import { useGizmoRender } from './useGizmoRender';  // ✅ Wire gizmo render
import { usePanelMove } from '../../../modules/panel';  // ✅ Panel taşıma
import { useSelector } from 'react-redux';
import { COMMANDS } from '../../../utils/commonProperties';

// ✅ Performans için gizmo limiti (şimdilik devre dışı - test için)
// const GIZMO_LIMIT = 20;

// Kat planı / vaziyet seçim modlarında gizmo oluşturma (performans).
const GIZMO_DISABLED_COMMANDS = new Set([COMMANDS.SELECT_FLOOR_PLAN, COMMANDS.SELECT_SITE_PLAN]);

export default function useGizmoManager(scene, camera, renderer) {
  const selectedObjectIds = useSelector(state => state.selection.selectedObjectIds);
  const commandType = useSelector(state => state.operation.commandType);

  const gizmoEnabled = !GIZMO_DISABLED_COMMANDS.has(commandType);
  const effectiveSelectedIds = gizmoEnabled ? selectedObjectIds : [];

  // ✅ WIRE GIZMO SİSTEMİ (render + interaksiyon)
  useGizmoRender(scene, camera, gizmoEnabled);  // Seçili wire'larda mavi kare gizmolar oluştur
  useGizmo(scene, camera, renderer?.domElement);  // Gizmo sürükleme ve snap
  useFixtureGizmo(scene, camera, renderer?.domElement); // ✅ Fixture wire spline gizmo
  useFixtureRotateGizmo(scene, effectiveSelectedIds); // ✅ Fixture mesh rotate gizmo visibility
  useFixtureRotateEvents({ scene, camera, renderer }); // ✅ Fixture mesh rotate handler

  // ✅ PANEL MOVE SİSTEMİ (M tuşu ile taşıma)
  usePanelMove(scene, camera, renderer?.domElement);

  // Özel sembol gizmoları
  useSocketGizmo(scene, effectiveSelectedIds);
  useSocketGizmoEvents({ scene, camera, renderer });
  useGroundingGizmo(scene, effectiveSelectedIds);
  useGroundingGizmoEvents({ scene, camera, renderer });
  useLightSwitchGizmo(scene, effectiveSelectedIds);
  useLightingGizmoEvents({ scene, camera, renderer });
  useMachineGizmo(scene, effectiveSelectedIds);
  useMachineGizmoEvents({ scene, camera, renderer });
//  useGizmoTitle(scene, camera, renderer, selectedObjects.map(id => scene.getObjectById(id)));
}
